import { render, staticRenderFns } from "./DeleteSolutionModal.vue?vue&type=template&id=4ed546d3&scoped=true"
import script from "./DeleteSolutionModal.vue?vue&type=script&lang=js"
export * from "./DeleteSolutionModal.vue?vue&type=script&lang=js"
import style0 from "./DeleteSolutionModal.vue?vue&type=style&index=0&id=4ed546d3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed546d3",
  null
  
)

export default component.exports